import React, { useState } from "react";
import { faCloudArrowUp, faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "../../vapor/button";
import "./style.scss";
import { IconDefinition, IconName } from "@fortawesome/fontawesome-svg-core";
import { useDropzone } from "react-dropzone";
import { FormattedMessage } from "react-intl";

interface DropzoneProps {
    onDrop: (val: any) => void;
    name: string;
    value?: any;
    open?: any;
    maxFiles?: number;
    maxSize?: number;
    accept?: any;
    onRemove: () => void;
}

function Dropzone(props: DropzoneProps) {
    const { getRootProps, getInputProps } = useDropzone({
        onDrop: props.onDrop,
        accept: props.accept,
        maxFiles: props.maxFiles,
        maxSize: props.maxSize,
    });
    return (
        <>
            <div {...getRootProps({ className: "dropzone" })}>
                <input
                    id={"bis-uploader-input_" + props.name}
                    className="bis-uploader-input-zone"
                    {...getInputProps()}
                />
                <div className="bis-uploader-dropzone-content">
                    <div className="bis-uploader-dropzone-content-text">
                        Trascina qui
                    </div>
                </div>
            </div>
            <div className="bis-uploader-buttons">
                <Button
                    onClick={() => {
                        document
                            .getElementById("bis-uploader-input_" + props.name)
                            ?.click();
                    }}
                    kind="tertiary"
                >
                    <FontAwesomeIcon icon={faCloudArrowUp} /> Carica foto
                </Button>
                <Button
                    disabled={props.value === ""}
                    kind="tertiary"
                    onClick={() => props.onRemove()}
                >
                    <FontAwesomeIcon icon={faTrashAlt} /> Rimuovi
                </Button>
            </div>
        </>
    );
}

interface UploaderProps {
    name: string;
    icon: IconName | IconDefinition;
    accept?: any;
    maxFiles?: number;
    maxSize?: number;
    file?: string;
    onFileSelect: (data: string) => void;
}

const Uploader = (props: UploaderProps) => {
    const [error, setError] = useState("");

    const onDrop = async ([file]: any, setError: any) => {
        if (file) {
            var reader = new FileReader();
            reader.onload = function (e: any) {
                props.onFileSelect(e.target.result);
            };
            reader.readAsDataURL(file);
        } else {
            setError("errors.uploader");
        }
    };

    return (
        <div className="bis-uploader">
            <div className="bis-uploader-dropZone">
                <div className="bis-uploader-image">
                    {props.file ? (
                        <div className="bis-uploader-image-withFile">
                            {<img src={props.file} alt="" />}
                        </div>
                    ) : (
                        <FontAwesomeIcon icon={props.icon} />
                    )}
                </div>
                <Dropzone
                    value={props.file}
                    maxSize={props.maxSize}
                    maxFiles={props.maxFiles}
                    accept={props.accept}
                    name={props.name}
                    onDrop={(file: any) => {
                        setError("");
                        onDrop(file, setError);
                    }}
                    onRemove={() => {
                        props.onFileSelect("");
                    }}
                />
                {!error && (
                    <div className="bis-uploader-tip">
                        <FormattedMessage id={"widgets.uploader.tip"} />
                    </div>
                )}
                {error && (
                    <div className="bis-uploader-tip-error">
                        <FormattedMessage id={error} />
                        <br />
                        <FormattedMessage id={"widgets.uploader.tip"} />
                    </div>
                )}
            </div>
        </div>
    );
};

Uploader.defaultProps = {
    maxFiles: 1,
    maxSize: 1000000,
};

export default Uploader;
